export default {
    methods: {
        setGlobalValues(values) {
            for (let key in values) {
                this.element.object.values[key] = values[key];
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/composer/Mixins/Global.js